exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".metrics{background:#fff;padding-bottom:100px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-c237a4bc!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Debug/DebugMetrics.vue
// module id = 56
// module chunks = 0